module.exports = __webpack_public_path__ + "img/PL08944.30b74dbd.png";